export var Suit;
(function (Suit) {
    Suit["Spades"] = "S";
    Suit["Hearts"] = "H";
    Suit["Clubs"] = "C";
    Suit["Diamonds"] = "D";
})(Suit || (Suit = {}));
export var Rank;
(function (Rank) {
    Rank["Ace"] = "A";
    Rank["King"] = "K";
    Rank["Queen"] = "Q";
    Rank["Jack"] = "J";
    Rank["Ten"] = "10";
    Rank["Nine"] = "9";
    Rank["Eight"] = "8";
    Rank["Seven"] = "7";
    Rank["Six"] = "6";
    Rank["Five"] = "5";
    Rank["Four"] = "4";
    Rank["Three"] = "3";
    Rank["Two"] = "2";
})(Rank || (Rank = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZ2FtZS1saWIvZGVmaW5pdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFOLElBQVksSUFLWDtBQUxELFdBQVksSUFBSTtJQUNmLG9CQUFZLENBQUE7SUFDWixvQkFBWSxDQUFBO0lBQ1osbUJBQVcsQ0FBQTtJQUNYLHNCQUFjLENBQUE7QUFDZixDQUFDLEVBTFcsSUFBSSxLQUFKLElBQUksUUFLZjtBQUVELE1BQU0sQ0FBTixJQUFZLElBY1g7QUFkRCxXQUFZLElBQUk7SUFDZixpQkFBUyxDQUFBO0lBQ1Qsa0JBQVUsQ0FBQTtJQUNWLG1CQUFXLENBQUE7SUFDWCxrQkFBVSxDQUFBO0lBQ1Ysa0JBQVUsQ0FBQTtJQUNWLGtCQUFVLENBQUE7SUFDVixtQkFBVyxDQUFBO0lBQ1gsbUJBQVcsQ0FBQTtJQUNYLGlCQUFTLENBQUE7SUFDVCxrQkFBVSxDQUFBO0lBQ1Ysa0JBQVUsQ0FBQTtJQUNWLG1CQUFXLENBQUE7SUFDWCxpQkFBUyxDQUFBO0FBQ1YsQ0FBQyxFQWRXLElBQUksS0FBSixJQUFJLFFBY2YifQ==